import apiClient from "./apiClient";


// GET ALL USERS
export const getAllUsers = async () => {

    const response = await apiClient.get(
        "/admin/getall"
    );

    return response.data;

};


// CREATE USER
export const createUser = async (data) => {

    const response = await apiClient.post(
        "/admin/register",
        data
    );

    return response.data;

};


// DELETE USER
export const deleteUser = async (id) => {

    const response = await apiClient.delete(
        `/admin/delete/${id}`
    );

    return response.data;

};

// GLOBAL SEARCH
export const globalSearch = async (query) => {
    const response = await apiClient.get(
        `/admin/global-search?query=${query}`
    );
    return response.data;
};